import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Idaho = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Idaho Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Two-page form required within 10 days of offer.
        </Text>

        <Text style={styles.listItem}>
          2. Property Condition Disclosure Act: Mandates disclosure of known
          material defects.
        </Text>

        <Text style={styles.listItem}>
          3. Water Rights: Disclosure required if applicable.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5. <Text style={styles.underline}>Seller's Property Disclosure</Text>{' '}
          – Sellers are required to complete this disclosure within 10 days of
          accepting an offer.
        </Text>
      </View>
    </View>
  );
};

export default Idaho;
